import BaseApiService from './BaseApiService';

class AuthenticationApiService extends BaseApiService {
    constructor() {
        super('auth');
    }

    async login(data) {
        return await this.request({ method: 'POST', url: '/login', data });
    }
}

export default new AuthenticationApiService();
